import { MINOR_PENALTY, MAJOR_PENALTY, PENALTYDATA, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    minorPenaltyData: [],
    majorPenaltyData: [],
    panaltyData: '',
}

export const penaltyReducer = (state = initialState, action) => {
    switch (action.type) {
        case MINOR_PENALTY:
            return {
                ...state,
                minorPenaltyData: action.payload
            };
        case MAJOR_PENALTY:
            return {
                ...state,
                majorPenaltyData: action.payload
            };
        case PENALTYDATA:
            return {
                ...state,
                panaltyData: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}